// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"114":"1e23d7f6","126":"b3f205f5"}[chunkId] + ".js";
};